import { create } from "zustand";
import { getAcademicYears } from "../../services/academicYear/academicYearService";

const isCurrentYear = (year) => {
  if (!year) return false;
  const flag = year.current ?? year.is_current ?? year.isCurrent;
  if (typeof flag === "string") {
    return flag.toLowerCase() === "true" || flag === "1";
  }
  return Boolean(flag);
};

// The API flags the year whose date range covers today. Between two academic
// years - over the summer - no year is flagged, and then the newest one is the
// only sensible default: the oldest is what the plain list order would give.
const latestYear = (years) =>
  years.reduce((latest, year) => {
    if (!latest) return year;
    const a = year.start_date || year.name || "";
    const b = latest.start_date || latest.name || "";
    return a > b ? year : latest;
  }, null);

export const useAcademicYearsStore = create((set) => ({
  academicYears: [],
  current: null,
  isLoading: false,
  error: null,

  fetchAcademicYears: async () => {
    set({ isLoading: true, error: null });
    try {
      const data = await getAcademicYears();
      // Handle both array and object with results property
      const years = Array.isArray(data) ? data : data?.results || [];
      const currentYear = years.find(isCurrentYear) || latestYear(years);
      set({ academicYears: years, current: currentYear, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
      console.error("Error fetching academic years:", error);
    }
  },

  setAcademicYears: (academicYears) => set({ academicYears }),
  setCurrent: (current) => set({ current }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
}));

// True once there is nothing left to wait for: the years are here, or the
// request failed and never will bring them. See useAcademicTermsReady.
export const useAcademicYearsReady = () =>
  useAcademicYearsStore(
    (state) => state.academicYears.length > 0 || Boolean(state.error)
  );
